import React, { useState, useEffect, useMemo } from "react";
import { get } from "lodash";
import { Table, Space, Spin } from "antd";
import {
  Box,
  Input,
  Icon,
  Flex,
  useDisclosure,
  Spacer,
  useToast,
} from "@chakra-ui/react";
import { RiDeleteBin6Line, RiSearch2Line } from "react-icons/ri";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import styles from "./ComManagerTable.module.scss";
import { useCommunityMaster } from "../../store/community/reducer";
import CommunityDeleteConfirmation from "../modals/CommunityDeleteConfirmation";
import CommunityDetailModal from "../modals/CommunityDetailModal";
import CommunityEditDrawer from "../drawer/CommunityEditDrawer";
import axios from "axios";
import { REQUEST_MASTER_COMMUNITY } from "../../store/community/communityActionTypes";
import { useDispatch } from "react-redux";
interface props {
  query: any;
}
const CommunityTable: React.FC<props> = ({ query }) => {
  const { masterCommunity, busy } = useCommunityMaster();
  console.log(masterCommunity, "masterCommunity");
  const dispatch = useDispatch();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(7);
  const searchColumns = useMemo(() => ["name", "email", "phone"], []);
  const [targetData, setTargetData] = useState<any>();

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const search = (community: Record<string, any>) => {
    const searchTerm = searchQuery.toLowerCase();
    return searchColumns.some((column) => {
      const value = get(community, column, "");
      return value.toString().toLowerCase().includes(searchTerm);
    });
  };

  const formatData = (communities: any[]) => {
    console.log("community", communities);
    return communities.map((community, index) => ({
      key: community._id,
      communityName: community.name,
      // ownerName: "Owner Name",
      phoneNumber: community.phone,
      email: community.email,
      totalEvents: community.totalEvents,
      // ownerName: community?.createdBy?.firstName,
      ownerName: `${community?.createdBy?.firstName} ${community?.createdBy?.lastName}`,
      createdDate: new Date().toLocaleDateString(),
      description: community.description,
      reasonForStarting: community.reason,
      originalData: community,
    }));
  };

  useEffect(() => {
    if (masterCommunity) {
      setLoading(true);

      // Filter based on activeTab
      const filteredCommunities = masterCommunity.filter((community: any) => {
        if (activeTab === "all") {
          return community;
        } else {
          return community.underReview === "UNDER_REVIEW";
        }
      });

      // Apply search if searchQuery exists
      const searchedData = searchQuery
        ? filteredCommunities.filter(search)
        : filteredCommunities;

      // Format the data
      const formattedData = formatData(searchedData);

      setData(formattedData);
      setLoading(false);
    }
  }, [masterCommunity, activeTab, searchQuery]);

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const deletes = (value: any) => {
    setTargetData(value);
    onDeleteOpen();
  };
  const updateEvent = (record: any) => {
    setTargetData(record);
    onOpen();
  };
  const handleDelete = (record: any) => {
    setTargetData(record);
    onDeleteOpen();
  };

  const allCommunitiesColumns: Array<any> = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Community Name",
      dataIndex: "communityName",
      width: 200,
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      width: 150,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 150,
    },
    {
      title: "Total Events",
      dataIndex: "totalEvents",
      width: 150,
    },
    {
      title: "Community Created Date",
      dataIndex: "createdDate",
      width: 200,
    },
    {
      title: "Details",
      dataIndex: "details",
      width: 100,
      // render: () => (
      //   <span style={{ color: "#D14343", cursor: "pointer" }}>View</span>
      // ),
      render: (_: any, record: any) => (
        // render: () => (
        <a
          href="#"
          style={{ color: "#ff4d4f" }}
          onClick={(e) => {
            e.preventDefault();
            setTargetData(record);
            onViewOpen();
          }}
        >
          View
        </a>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      render: (_: any, record: any) => (
        <Space size="middle">
          {/* <EditOutlined
            style={{ color: "#1890ff", cursor: "pointer" }}
            // onClick={() => updateEvent(record.originalData)}
          /> */}
          <RiDeleteBin6Line
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => handleDelete(record.originalData)}
          />
        </Space>
      ),
    },
  ];

  const pendingRequestsColumns: Array<any> = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Community Name",
      dataIndex: "communityName",
      width: 180,
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      width: 150,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: 180,
    },
    {
      title: "Reason for starting",
      dataIndex: "reasonForStarting",
      width: 200,
    },
    {
      title: "Action",
      key: "action",
      width: 300,
      render: (_: any, record: any) => (
        <Space size="middle">
          <button
            style={{
              backgroundColor: "#02A432",
              color: "white",
              border: "none",
              padding: "10px 12px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
            onClick={() => {
              handleApprove(record);
            }}
          >
            Approve
          </button>
          <button
            style={{
              backgroundColor: "#D42F2F",
              color: "white",
              border: "none",
              padding: "10px 12px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
            onClick={() => {
              handleReject(record);
            }}
          >
            Reject
          </button>
          <button
            style={{
              backgroundColor: "#1F8FF9",
              color: "white",
              border: "none",
              padding: "10px 12px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.preventDefault();
              setTargetData(record);
              onViewOpen();
            }}
          >
            View
          </button>
        </Space>
      ),
    },
  ];

  const handleApprove = async (record: any) => {
    await axios({
      url: `${process.env.REACT_APP_BASE_URL}/admin/community/${record.originalData._id}`,
      method: "patch",
      data: {
        underReview: "APPROVE",
      },
    })
      .then((res) => {
        console.log("resss", res.data.data);
        dispatch({ type: REQUEST_MASTER_COMMUNITY });
        toast({
          title: "Success",
          description: "Community Approved successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      })
      .catch((error) => {
        console.log("errrrr", error);
        setLoading(false);
        toast({
          title: "Error",
          description: "An error occurred while approving community data",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      });
  };
  const handleReject = async (record: any) => {
    await axios({
      url: `${process.env.REACT_APP_BASE_URL}/admin/community/${record.originalData._id}`,
      method: "patch",
      data: {
        underReview: "REJECT",
      },
    })
      .then((res) => {
        console.log("resss", res.data.data);
        dispatch({ type: REQUEST_MASTER_COMMUNITY });
        toast({
          title: "Success",
          description: "Community Rejected successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      })
      .catch((error) => {
        console.log("errrrr", error);
        setLoading(false);
        toast({
          title: "Error",
          description: "An error occurred while rejecting community data",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      });
  };
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div
      style={{
        width: "96vw",
        maxWidth: "96vw",
        maxHeight: "86vh",
        height: "86vh",
        top: "8vh ",
        left: "4vw",
        overflowY: "auto",
        position: "relative",
        backgroundColor: "#EEEEEE",
        padding: "30px",
      }}
    >
      <div className={styles.headerSection}>
        <Box className={styles.searchBox}>
          <Box className={styles.searchIcon}>
            <Icon as={RiSearch2Line} width={"24px"} height={"24px"} />
          </Box>
          <Input
            placeholder="Search or type a command"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={styles.searchInput}
            padding={"0px"}
            lineHeight={"24px"}
          />
        </Box>
        <Flex w={"full"} justifyContent={"space-between"} alignItems={"center"}>
          <div className={styles.tabs}>
            <button
              className={`${styles.tab} ${
                activeTab === "all" ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab("all")}
            >
              All Communities
            </button>
            <button
              className={`${styles.tab} ${
                activeTab === "pending" ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab("pending")}
            >
              Pending requests
            </button>
          </div>
          <Spacer />
          {/* <Box
            background="#E24441"
            fontSize={"sm"}
            color="#fff"
            w="fit-content"
            textAlign="center"
            p={3}
            onClick={() => {
              onOpen();
              setTargetData(null);
            }}
            cursor="pointer"
            borderRadius="8px"
            _hover={{ background: "#E24441" }}
          >
            + Add Community
          </Box> */}
        </Flex>
      </div>

      <div className={styles.tableContainer}>
        {loading ? (
          <Spin size="large" />
        ) : (
          <Table
            rowSelection={rowSelection}
            rowKey="key"
            columns={
              activeTab === "all"
                ? allCommunitiesColumns
                : pendingRequestsColumns
            }
            dataSource={data}
            scroll={{ x: "max-content" }}
            size="middle"
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            // className={styles.table}

            rowClassName={(record: any) => record.color}
            loading={busy && data.length === 0 ? true : false}
          />
        )}
      </div>
      {isOpen && (
        <CommunityEditDrawer
          isOpen={isOpen}
          onClose={onClose}
          commData={targetData}
        />
      )}
      {isDeleteOpen && targetData && (
        <CommunityDeleteConfirmation
          isOpen
          onClose={onDeleteClose}
          event={targetData}
        />
      )}
      {isViewOpen && (
        <CommunityDetailModal
          isOpen={isViewOpen}
          onClose={onViewClose}
          commData={targetData}
        />
      )}
    </div>
  );
};

export default CommunityTable;
